export const FLEET_EMBED_STORAGE_KEY = 'isFleetEmbed';
export const FLEET_EMBED_LANG_STORAGE_KEY = 'fleetEmbedLang';

/**
 * @deprecated Origin allowlists are no longer used for Fleet postMessage.
 * Trust the embedding parent via {@link isTrustedFleetParentMessage} instead.
 * Kept so older imports/tests keep compiling.
 */
export const FLEET_EMBED_ORIGINS = [
  'https://fleet.azuga.com',
  'https://integration-web.azuga.com',
  'http://localhost:5500',
  'http://127.0.0.1:5500',
  'http://localhost:4200',
  'http://127.0.0.1:4200',
] as const;

/**
 * @deprecated Use {@link isTrustedFleetParentMessage}. Always returns true —
 * Fleet may be hosted on any origin.
 */
export function isAllowedFleetEmbedOrigin(_origin: string): boolean {
  return true;
}

export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin access to window.top can throw in some browsers.
    return true;
  }
}

/**
 * Accept Fleet embed contracts only from the window that embeds this portal.
 * Parent host can be prod/stage/integration/local — origin string is ignored.
 */
export function isTrustedFleetParentMessage(event: MessageEvent): boolean {
  if (!isInIframe()) {
    return false;
  }
  try {
    return event.source === window.parent;
  } catch {
    return false;
  }
}

export function setFleetEmbedInStorage(enabled: boolean): void {
  try {
    if (enabled) {
      window.sessionStorage.setItem(FLEET_EMBED_STORAGE_KEY, 'true');
    } else {
      window.sessionStorage.removeItem(FLEET_EMBED_STORAGE_KEY);
    }
  } catch {
    // sessionStorage may be unavailable in some environments.
  }
}

export function getFleetEmbedFromStorage(): boolean {
  try {
    return window.sessionStorage.getItem(FLEET_EMBED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Sync detect: iframe + (`?isFleet=true` or persisted embed flag from hideElements).
 * Does not depend on parent origin — Fleet can be hosted anywhere.
 */
export function isLikelyFleetEmbed(): boolean {
  if (!isInIframe()) {
    return false;
  }

  if (getFleetEmbedFromStorage()) {
    return true;
  }

  try {
    if (new URL(window.location.href).searchParams.get('isFleet') === 'true') {
      setFleetEmbedInStorage(true);
      return true;
    }
  } catch {
    // Invalid location href.
  }

  return false;
}

/** Whether fleet embed mode is currently active (iframe + persisted/detected). */
export function isFleetEmbedActive(): boolean {
  return isInIframe() && (getFleetEmbedFromStorage() || isLikelyFleetEmbed());
}


export function setFleetEmbedLangInStorage(languageCode: string | null): void {
  try {
    if (languageCode) {
      window.sessionStorage.setItem(FLEET_EMBED_LANG_STORAGE_KEY, languageCode);
    } else {
      window.sessionStorage.removeItem(FLEET_EMBED_LANG_STORAGE_KEY);
    }
  } catch {
    // sessionStorage may be unavailable in some environments.
  }
}

export function getFleetEmbedLangFromStorage(): string | null {
  try {
    return window.sessionStorage.getItem(FLEET_EMBED_LANG_STORAGE_KEY);
  } catch {
    return null;
  }
}
